'use strict'

module.exports = require('./src/')



// WEBPACK FOOTER //
// ./components/vc-tree/index.js